(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portfolio-project-detail"]) return;
  try {
    
(function () {
  'use strict';

  // Build dataset for each gallery from triggers
  function indexGalleries(root) {
    var galleries = {};
    root.querySelectorAll('[data-lightbox-trigger]').forEach(function (btn) {
      var key = btn.getAttribute('data-gallery');
      if (!galleries[key]) galleries[key] = [];
      galleries[key].push({
        full: btn.getAttribute('data-full'),
        alt: btn.getAttribute('data-alt') || '',
        index: parseInt(btn.getAttribute('data-index'), 10) || 0
      });
    });
    Object.keys(galleries).forEach(function (k) {
      galleries[k].sort(function (a, b) { return a.index - b.index; });
    });
    return galleries;
  }

  // Strip horizontal scroll arrows
  function wireStripArrows(root) {
    root.querySelectorAll('.ppd__strip-wrap').forEach(function (wrap) {
      var strip = wrap.querySelector('[data-strip]');
      var prev = wrap.querySelector('[data-strip-prev]');
      var next = wrap.querySelector('[data-strip-next]');
      if (!strip) return;
      var step = function () {
        var firstThumb = strip.querySelector('.ppd__thumb');
        if (!firstThumb) return strip.clientWidth * 0.8;
        return firstThumb.getBoundingClientRect().width * 2 + 28;
      };
      if (prev) prev.addEventListener('click', function () {
        strip.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        strip.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  }

  // Lightbox controller
  function initLightbox(root) {
    var lb = root.querySelector('[data-lightbox]');
    if (!lb) return;
    var imgEl = lb.querySelector('[data-lightbox-img]');
    var counterEl = lb.querySelector('[data-lightbox-counter]');
    var altEl = lb.querySelector('[data-lightbox-alt]');
    var closeBtn = lb.querySelector('[data-lightbox-close]');
    var prevBtn = lb.querySelector('[data-lightbox-prev]');
    var nextBtn = lb.querySelector('[data-lightbox-next]');

    var galleries = indexGalleries(root);
    var current = { key: null, index: 0 };
    var lastFocus = null;

    function render() {
      var list = galleries[current.key];
      if (!list || !list.length) return;
      var item = list[current.index];
      imgEl.src = item.full;
      imgEl.alt = item.alt;
      altEl.textContent = item.alt;
      counterEl.textContent = (current.index + 1) + ' / ' + list.length;
      var single = list.length <= 1;
      prevBtn.style.display = single ? 'none' : '';
      nextBtn.style.display = single ? 'none' : '';
    }

    function open(key, index) {
      if (!galleries[key]) return;
      lastFocus = document.activeElement;
      current.key = key;
      current.index = Math.max(0, Math.min(index, galleries[key].length - 1));
      render();
      lb.hidden = false;
      document.body.classList.add('ppd-lightbox-open');
      closeBtn.focus();
    }
    function close() {
      lb.hidden = true;
      document.body.classList.remove('ppd-lightbox-open');
      imgEl.src = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function step(delta) {
      var list = galleries[current.key];
      if (!list) return;
      current.index = (current.index + delta + list.length) % list.length;
      render();
    }

    root.querySelectorAll('[data-lightbox-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-gallery'), parseInt(btn.getAttribute('data-index'), 10) || 0);
      });
    });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb) close(); // click backdrop
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });

    // Touch swipe (basic)
    var touchStartX = null;
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
      touchStartX = null;
    });
  }

  function init() {
    document.querySelectorAll('.section--portfolio-project-detail').forEach(function (root) {
      wireStripArrows(root);
      initLightbox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
